import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export const scrollToCompra = (e: React.MouseEvent) => {
  e.preventDefault();
  const compraSection = document.getElementById('compra');
  if (compraSection) {
    compraSection.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
export const CTAButton = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <motion.button onClick={scrollToCompra} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-grass-400 text-forest-950 font-anton text-xl md:text-2xl uppercase tracking-wide py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(130,194,72,0.4)] hover:shadow-[0_0_30px_rgba(130,194,72,0.6)] transition-shadow duration-300 ${className}`} data-id="element-110">
      {children}
    </motion.button>;
};
export const ClickableImage = ({
  src,
  alt,
  className = ''
}: {
  src: string;
  alt: string;
  className?: string;
}) => {
  return <motion.div whileHover={{
    scale: 1.01
  }} className={`cursor-pointer overflow-hidden rounded-xl border border-forest-800 shadow-2xl ${className}`} onClick={scrollToCompra} data-id="element-111">
      <img src={src} alt={alt} className="w-full h-full object-cover hover:opacity-90 transition-opacity" data-id="element-112" />
    </motion.div>;
};
const BUYERS = [{
  name: 'Martín',
  city: 'Rosario'
}, {
  name: 'Agustín',
  city: 'Córdoba'
}, {
  name: 'Facundo',
  city: 'La Plata'
}, {
  name: 'Nicolás',
  city: 'Mendoza'
}, {
  name: 'Thiago',
  city: 'Mar del Plata'
}, {
  name: 'Benjamín',
  city: 'Salta'
}, {
  name: 'Ignacio',
  city: 'Tucumán'
}, {
  name: 'Valentín',
  city: 'Bahía Blanca'
}, {
  name: 'Santiago',
  city: 'Neuquén'
}, {
  name: 'Bruno',
  city: 'San Juan'
}];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerData, setBuyerData] = useState({
    name: '',
    city: '',
    time: 1
  });
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const showRandomBuyer = () => {
    const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
    const randomTime = Math.floor(Math.random() * 12) + 1;
    setBuyerData({
      ...randomBuyer,
      time: randomTime
    });
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(showRandomBuyer, Math.random() * 10000 + 12000);
    }, 5000);
  };
  return <AnimatePresence data-id="element-113">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-forest-900 border border-forest-700 rounded-lg shadow-2xl p-4 pr-12 max-w-sm flex items-start gap-3" data-id="element-114">
          <div className="w-3 h-3 bg-grass-400 rounded-full mt-1.5 animate-pulse flex-shrink-0" data-id="element-115" />
          <div data-id="element-116">
            <p className="text-sm text-forest-200" data-id="element-117">
              <span className="font-bold text-white" data-id="element-118">{buyerData.name}</span> de{' '}
              {buyerData.city} acaba de comprar{' '}
              <span className="text-grass-400 font-semibold" data-id="element-119">
                Arquero PRO System
              </span>
            </p>
            <p className="text-xs text-forest-400 mt-1" data-id="element-120">
              hace {buyerData.time} minutos
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-forest-400 hover:text-white transition-colors" data-id="element-121">
            <X size={16} data-id="element-122" />
          </button>
        </motion.div>}
    </AnimatePresence>;
};
export const Footer = () => <footer className="bg-forest-950 py-8 border-t border-forest-800 text-center text-forest-400 text-sm" data-id="element-123">
    <p data-id="element-124">
      © {new Date().getFullYear()} Arquero PRO System. Todos los derechos
      reservados.
    </p>
    <p className="mt-2" data-id="element-125">
      Este sitio no es parte del sitio web de Facebook o Facebook Inc. Además,
      este sitio NO está respaldado por Facebook de ninguna manera.
    </p>
  </footer>;